import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isAndroid } from '@helpers';
import TouchableElement from '@components/common/touchableElement';
import LineButton from '@components/common/lineButton';

import { getBoxShadowStyle } from '@styles/shadow';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const {
    C,
    user: { featureFlagsEnv = {} },
    route,
    getAllFeatureFlags,
  } = props;

  const [loading, setLoding] = useState(false);

  const selectedEnv = route?.params?.env || 'dev';

  const data = featureFlagsEnv[selectedEnv];

  if (!data) {
    return (
      <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
        <Text
          style={[
            font.Headline,
            {
              color: C('Label / Light / Primary'),
              width: '100%',
              textAlign: 'center',
            },
          ]}
        >
          {i18n.t('No information')}
        </Text>
      </View>
    );
  }

  const renderData = [];

  Object.keys(data).forEach((key) => {
    const info = {
      title: key,
      render: [],
    };

    Object.keys(data[key]).forEach((property) => {
      info.render.push({ name: property, value: data[key][property] });
    });

    renderData.push(info);
  });

  return (
    <View style={{ marginTop: scale(28) }}>
      {renderData.map((props) => (
        <View key={props.title} style={{ marginBottom: scale(28) }}>
          <View style={{ width: '100%', paddingLeft: scale(16), marginBottom: scale(5) }}>
            <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary'), textTransform: 'uppercase' }]}>{i18n.t(props.title)}</Text>
          </View>
          <View
            style={[
              getBoxShadowStyle({ type: 'Field', C }),
              {
                width: '100%',
                borderRadius: scale(SCREEN_BORDER_RADIUS),
              },
            ]}
          >
            {props.render.map((item, index) => {
              const firstIndex = index === 0;
              const lastIndex = index === props.render.length - 1;
              return (
                <View key={item.name} style={{ width: '100%' }}>
                  <TouchableElement>
                    {({ pressHoverColor, boxStyle }) => (
                      <View
                        style={[
                          boxStyle,
                          {
                            marginTop: isAndroid ? StyleSheet.hairlineWidth : 0,
                            paddingLeft: scale(15),
                            backgroundColor: C(pressHoverColor('Background / Light / Field')),
                            zIndex: props.render.length - index,
                          },
                          firstIndex && {
                            borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                            borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
                          },
                          lastIndex && {
                            borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                            borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
                          },
                        ]}
                      >
                        <View style={{ height: scale(46), width: '100%', flexDirection: 'row' }}>
                          <View
                            style={[
                              !lastIndex && {
                                borderBottomColor: C('Hairline / Light / No trans'),
                                borderBottomWidth: StyleSheet.hairlineWidth,
                              },
                              { flex: 1, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' },
                            ]}
                          >
                            <Text style={[font['Body'], { color: C('Label/Light/Primary') }]}>{i18n.t(item.name)}</Text>
                            <View style={{ justifyContent: 'center', marginRight: scale(16), opacity: item.value ? 1 : 0 }}>
                              <Svg icon="check" color="Label/Light/Tertiary" width={scale(19)} height={scale(19)} />
                            </View>
                          </View>
                        </View>
                      </View>
                    )}
                  </TouchableElement>
                </View>
              );
            })}
          </View>
        </View>
      ))}
      <LineButton
        {...{
          onPress: async () => {
            setLoding(true);
            await getAllFeatureFlags();
            setLoding(false);
          },
          text: 'Reload Feature Flags',
          color: 'Link/Light/Primary',
          C,
          loading,
        }}
      />
    </View>
  );
};
